import { Box, ChakraProps } from '@chakra-ui/react'
import { FC, ReactNode } from 'react'

export const PageRoot: FC<{ children: ReactNode } & ChakraProps> = ({ children, ...props }) => {
  return (
    <Box
      width="100%"
      minHeight="100vh"
      sx={{
        // iOS Safari は 100vh がブラウザ UI を含む高さになり、末尾のフッターがファーストビュー外に出るため
        '@supports(-webkit-touch-callout: none)': {
          minHeight: '-webkit-fill-available',
        },
      }}
      display="flex"
      flexDirection="column"
      overflowY="auto"
      {...props}
    >
      {children}
    </Box>
  )
}
